// extracted by mini-css-extract-plugin
export default {"dollar":"JIrJJp2PHtCYd5RNyM83","symbol":"VooFoeV3vIJmbaIK8vo7"};